// app/Providers.tsx
"use client";

import { useEffect } from "react";
import { SocialLogin } from "@capgo/capacitor-social-login";
import { SubscriptionProvider } from "@/contexts/SubscriptionContext";

export default function Providers({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    SocialLogin.initialize({
      google: {
        webClientId: "362688989926-d5gqpd0htkhuqobrnsb6p9i9gc1969th.apps.googleusercontent.com",
      },
    });
  }, []); // empty dependency = runs once

  return <SubscriptionProvider>{children}</SubscriptionProvider>;
}
